import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-container">
      <h2>About Transform 365 Business Solutions</h2>
      <p className="about-description">
        At Transform 365 Business Solutions, we have deep experience in transforming manual, paper-based, or legacy processes into digital solutions that people actually use and love. Our team specializes in making technology approachable and effectively bridging the gap between business needs and real-world adoption.
      </p>
      <p className="about-description">
        We believe that digital transformation is not just about technology, but about empowering people to work smarter, faster, and with greater satisfaction. Our expertise in Microsoft Dynamics 365, Power Platform, Azure, and Power Pages enables us to deliver solutions that modernize operations, automate processes, and create impactful digital experiences for organizations of all sizes.
      </p>

     
    </div>
  );
};

export default About;
